export default "__VITE_ASSET__DQTsXqSK__"